import ChartContainer from '@synergy/charts';
import useFetch from '../../../server/useFetch';
import { useEffect, useState } from 'react';
import Spinner from './Spinner';
import query from '../../../server/constants.api';
import logger from '../../../server/logger';

export const RenderChart = ({ chartdata, charttype, chartquery, idQuery, clickTooltipData, height, width, chartId, yearsToFetch, fetchIsLoading, municipalitiesToFetch, idToFetch, energyType, filters, language, title }) => {
    const parsedParams = JSON.stringify(yearsToFetch);
    // const params = yearsToFetch ? { dates: parsedParams } : null;
    const { data: widgetData, isLoading: widgetDataIsLoading, refetch: refetchWidgetData, isFetching } = useFetch(chartquery, idQuery, { dates: parsedParams, tenant: municipalitiesToFetch, id: idToFetch, energyType: energyType, language: language, filters: filters }, false);
    const [chartData, setChartData] = useState(null);

    useEffect(() => {
        try {

            if (widgetData?.data) {
                setChartData(chartquery === query.path.emissionsBySector ?widgetData?.data?.data  : widgetData?.data);
                // logger.info('(RenderChart page) UseEffect setting chartData if exists widgetData');
            }
            if (fetchIsLoading) {
                fetchIsLoading(isFetching);//To disable dates dropdown when isFetching
            }
        } catch (error) {
            // logger.error('(RenderChart page) Error in useEffect setting chartData if exists widgetData');
            console.error('(RenderChart page) Error in useEffect setting chartData if exists widgetData:', error);
            //reportError(error); // Send error report to backend
        }
    }, [widgetData?.data]);

    useEffect(() => {
        try {
            if (chartdata) {
                setChartData(chartdata);
                // logger.info('(RenderChart page) UseEffect setting chartData if exists widgetData');
            }
            if (fetchIsLoading) {
                fetchIsLoading(isFetching);//To disable dates dropdown when isFetching
            }
        } catch (error) {
            // logger.error('(RenderChart page) Error in useEffect setting chartData');
            console.error('(RenderChart page) Error in useEffect setting chartData:', error);
            //reportError(error); // Send error report to backend
        }
    }, [chartdata]);

    useEffect(() => {
        try {
            refetchWidgetData();
            // logger.info('(RenderChart page) UseEffect refetching widgetData');
        } catch (error) {
            // logger.error('(RenderChart page) Error in useEffect refetchWidgetData');
            console.error('(RenderChart page) Error in useEffect refetchWidgetData:', error);
            //reportError(error); // Send error report to backend
          }
    }, [yearsToFetch, municipalitiesToFetch, energyType, filters, language])

    return (
        <>
            {
                (chartData && !widgetDataIsLoading && !isFetching) ?
                    <ChartContainer charttype={charttype} clickTooltipData={clickTooltipData} height={height} width={width} chartData={chartData} chartId={chartId} language={language} title={title} />
                    : <Spinner stroke="green" />
            }
        </>
    )
}